import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthService } from '@auth0/auth0-angular';
import { getPortalVersion, PortalVersion } from 'src/app/app.module';
import { DeniedDialogComponent } from 'src/app/glp-common/components/denied-dialog/denied-dialog.component';
import { ActivityType } from 'src/app/models/ActivityType';
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { UserService } from 'src/app/services/user.service';
import { LoggingService } from 'src/app/utilities/logging.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-not-approved',
  templateUrl: './not-approved.component.html',
  styleUrls: ['./not-approved.component.scss']
})
export class NotApprovedComponent implements OnInit {
  userEmail: string;
  constructor(
    private dialog: MatDialog,
    public auth: AuthService,
    private logService: ActivityLogService,
    private userService: UserService,
    private loggingService: LoggingService
  ) { }

  ngOnInit() {

    this.auth.user$.subscribe((account) => {

      this.logService.log(account.email, account.is_Broker, ActivityType.RejectedLogin, account.email).subscribe(
        (data) => {
        },
        (err) => {
                  this.loggingService.logException(err, 3);
        }
      );
      const errorDialogConfig = new MatDialogConfig();

      let title = '';
      let message = '';
      if(account.is_Broker){
        title = 'Pending Account Access';
        message = 'Your account is currently under review and you will be notified once access is approved. If access has been approved, your account may have been disabled. To learn more or reactivate your account, please contact your account team for further assistance.'
      }
      else if (account.is_group_leader || account.compeleted_registration){
        title = 'Pending Account Access';
        message = 'Your account is currently under review and you will be notified once access is approved.';
      }
      else{
        title = 'Denied account access';
        message = 'You do not currently have an account for this portal. If you believe this is an error, please reach out to your internal representative.'
      }

      errorDialogConfig.data = {
        title: title,
        message: message,
        footermessage: ' '
      };
      this.dialog.open(DeniedDialogComponent, errorDialogConfig);
      let logoutUrl = getPortalVersion() == PortalVersion.EOA ? environment.redirectUrlGL : environment.redirectUrlBroker;
      this.dialog.afterAllClosed.subscribe((_) => this.auth.logout({ logoutParams: { returnTo: logoutUrl } }));
    });

  }


}
